import type { FaireProductEntity } from "../../entity_types/product";

export const p_jvkdrtjdg8: FaireProductEntity = {
  token: "p_jvkdrtjdg8",
  type: "product",
  name: "An Apple a Day Market Pad",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/de9412f29d1831c19f77b6a33f552e3f676791ad518ae7fcc180838dcd264cee.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8101f3034c3641d28a96c3e4afdaa2a77704b774fef76a2f2d48dbad1c1ac613.jpeg",
    "https://cdn.faire.com/fastly/69c432d24927a1a6d7662fe8108365fcc0f68794bb64f3d34d8f9cb98811ef46.jpeg",
  ],
  priceDollars: 8,
  description:
    "Ah, the ol' kitchen list. As soon as you've gotten everything on it, it's time to start a new one. So add cheer to the chore with a cute notepad! It might even make you smile as you write down salad. Again.",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:19.300Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
